import ReactDOM from 'react-dom';
import React, { PureComponent } from 'react';
import { Toast, Icon, InputItem, List, Picker, Popup } from 'antd-mobile';
import tips from 'tips';
import Btn from 'Btn';
import './index.less';

const ListItem = List.Item;

let popupQueue = [];

class BankAuth extends PureComponent {
  static defaultProps = {
    isDomestic: true,
    psgList: [],
    switchPsg: () => {},
    getCode: () => {},
    submit: () => {},
    destroy: () => {},
  };

  constructor(props) {
    super(props);
    const { isDomestic } = this.props;
    this.state = Object.assign(
      {},
      {
        pickerData: this.props.psgList.map(item => ({
          label: item.psgName,
          value: item.ticketNo,
        })),
        pickerValue: isDomestic ? this.props.psgList[0].ticketNo : '',
        code: '',
        seconds: 59,
        timer: false,
        cardInfo: {
          showName: isDomestic ? this.props.psgList[0].psgName : '',
          name: isDomestic ? this.props.psgList[0].psgName : '', // 持卡人
          certno: isDomestic ? this.props.psgList[0].certificateIdDis : '', // 证件号
          account: '', // 银行卡号
          phone: '', // 手机
          province: '', // 省
          city: '', // 城市
          address: '', // 开户地址,
          bank: '', // 开户银行
          ticketNo: this.props.psgList[0].ticketNo, // 客票号
        },
      }
    );
  }

  // 编辑卡号
  _inputChange = key => value => {
    if (Object.keys(this.state.cardInfo).includes(key)) {
      let cardInfo = { ...this.state.cardInfo };
      if (key === 'showName' || key === 'name') {
        cardInfo['showName'] = value.replace(/[^\u4e00-\u9fa5]/g, '');
        cardInfo['name'] = value.replace(/[^\u4e00-\u9fa5]/g, '');
      } else {
        cardInfo[key] = value;
      }
      this.setState({
        cardInfo,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
  };

  _inputClear = key => () => {
    if (Object.keys(this.state.cardInfo).includes(key)) {
      let cardInfo = { ...this.state.cardInfo };
      cardInfo[key] = '';
      this.setState({
        cardInfo,
      });
    } else {
      this.setState({
        [key]: '',
      });
    }
  };

  // 获取验证码
  getverification = async () => {
    const { cardInfo } = this.state;
    const { lang } = this.props;
    if (!/^1\d{10}$/.test(cardInfo.phone) || cardInfo.phone.length !== 11) {
      Toast.info(lang.applySubmit.eleven_phone, 1);
      return false;
    }

    this.setState({ timer: true });
    this.verbtn.style.color = '#b2b0bc';
    const settimer = setInterval(() => {
      this.setState(
        preState => ({
          seconds: preState.seconds - 1,
        }),
        () => {
          if (this.state.seconds === -1) {
            clearInterval(settimer);
            this.setState({ seconds: 59, timer: false });
            this.verbtn.style.color = '#0073df';
          }
        }
      );
    }, 1000);
    await this.props.getCode(cardInfo.phone);
  };

  _submit = () => {
    const { code, cardInfo, timer } = this.state;
    const { lang } = this.props;
    if (!cardInfo.name) {
      Toast.info(lang.applySubmit.error_name, 1);
      return false;
    }

    if (!cardInfo.certno) {
      Toast.info(lang.applySubmit.error_certno, 1);
      return false;
    }

    if (cardInfo.account === '') {
      Toast.info(lang.applySubmit.no_bankcard, 1);
      return false;
    }

    if (!cardInfo.phone || cardInfo.phone.length !== 11) {
      Toast.info(lang.applySubmit.eleven_phone, 1);
      return false;
    }

    if (!code) {
      Toast.info(lang.applySubmit.no_verification, 1);
      return false;
    }
    if (code.length < 6) {
      Toast.info(lang.applySubmit.error_verification, 1);
      return false;
    }
    if (!timer) {
      Toast.info(lang.applySubmit.overtime_verification, 1);
      return false;
    }

    this.props.submit(code, cardInfo);
  };

  _pickerConfirm = npsg => value => {
    const { psgList, switchPsg } = this.props;
    const v = Array.isArray(value) ? value[0] : value;
    const psg = npsg || psgList.filter(item => item.ticketNo === v)[0];
    switchPsg(psg, () => {
      this.setState({
        pickerValue: v,
        cardInfo: {
          showName: psg.psgName,
          name: psg.psgName,
          certno: psg.certificateIdDis,
          account: this.state.cardInfo.account,
          phone: this.state.cardInfo.phone,
          ticketNo: psg.ticketNo,
        },
      });
    });
  };

  _onCancel = () => {
    this.props.destroy();
  };

  render() {
    const { isDomestic } = this.props;
    const {
      pickerData,
      pickerValue,
      code,
      cardInfo,
      seconds,
      timer,
    } = this.state;
    const { lang } = this.props;
    return (
      <div className="bankPopup">
        <div
          id="cet"
          className="content"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
        >
          <Icon
            type="cross"
            onClick={this._onCancel}
            role="button"
            aria-label="关闭"
          />
          <p>{lang.refundMoth}</p>
          <div className="bankAuth">
            <div className="reminder">
              <span className="reminder_hint">{lang.inpIdCard}</span>
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.cardholder}</div>
                <div className="bankCardMsg_right cardNo">
                  {isDomestic ? (
                    <Picker
                      cols={1}
                      data={pickerData}
                      value={[pickerValue]}
                      okText="确定"
                      onOk={this._pickerConfirm()}
                    >
                      <ListItem arrow="horizontal">
                        {lang.choosePerson}
                      </ListItem>
                    </Picker>
                  ) : (
                    <InputItem
                      type="string"
                      value={cardInfo.showName}
                      placeholder={lang.inpMessage}
                      onChange={this._inputChange('name')}
                      clear={true}
                    />
                  )}
                </div>
              </div>
              <div className="bankCardLine" />
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.updateDetail55}</div>
                <div className="bankCardMsg_right">
                  {isDomestic ? (
                    <span className="cardholder">{cardInfo.certno}</span>
                  ) : (
                    <InputItem
                      type="string"
                      value={cardInfo.certno}
                      placeholder={lang.inpMessage2}
                      maxLength={39}
                      onChange={this._inputChange('certno')}
                      clear={true}
                    />
                  )}
                </div>
              </div>
              <div className="bankCardLine" />
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.cardNum}</div>
                <div className="bankCardMsg_right">
                  <InputItem
                    type="number"
                    value={cardInfo.account
                      .replace(/\s/g, '')
                      .replace(/[^\d]/g, '')
                      .replace(/(\d{4})(?=\d)/g, '$1 ')}
                    placeholder={lang.inpIdCard2}
                    maxLength={39}
                    onChange={this._inputChange('account')}
                    clear={this._inputClear('account')}
                  />
                </div>
              </div>
              <div className="bankCardLine" />
              <div className="originalBankWarn">{lang.cardtip}</div>
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.refundMoth1}</div>
                <div className="bankCardMsg_right">
                  <InputItem
                    type="string"
                    value={cardInfo.province}
                    placeholder={lang.refundMoth2}
                    onChange={this._inputChange('province')}
                    clear={this._inputClear('province')}
                  />
                </div>
              </div>
              <div className="bankCardLine" />
              <div className="originalBankWarn">{lang.refundMoth3}</div>
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.refundMoth4}</div>
                <div className="bankCardMsg_right">
                  <InputItem
                    type="string"
                    value={cardInfo.city}
                    placeholder={lang.refundMoth5}
                    onChange={this._inputChange('city')}
                    clear={this._inputClear('city')}
                  />
                </div>
              </div>
              <div className="bankCardLine" />
              <div className="originalBankWarn">{lang.refundMoth6}</div>
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.refundMoth4567}</div>
                <div className="bankCardMsg_right">
                  <InputItem
                    type="string"
                    value={cardInfo.address}
                    placeholder={lang.refundMoth7}
                    onChange={this._inputChange('address')}
                    clear={this._inputClear('address')}
                  />
                </div>
              </div>
              <div className="bankCardLine" />
              <div className="originalBankWarn">{lang.refundMoth8}</div>
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <div className="bankCardMsg_left">{lang.refundMoth9}</div>
                <div className="bankCardMsg_right">
                  <InputItem
                    type="number"
                    value={cardInfo.phone.replace(/\s/g, '')}
                    maxLength={11}
                    clear={true}
                    placeholder={lang.refundMoth0}
                    onChange={this._inputChange('phone')}
                  />
                </div>
              </div>
              <div className="bankCardLine" />
            </div>

            <div className="bankCardLi">
              <div className="bankCardMsg">
                <InputItem
                  type="number"
                  style={{ marginLeft: '21px', width: '310px' }}
                  value={code}
                  maxLength={6}
                  onChange={this._inputChange('code')}
                  placeholder={lang.refundMoth11}
                  clear={true}
                />
                <div className="acquierVerification">
                  {timer && <span> ({seconds}s) </span>}
                  <button
                    disabled={timer ? 'disabled' : ''}
                    onClick={this.getverification}
                    ref={verbtn => (this.verbtn = verbtn)}
                  >
                    {lang.checkCode}
                  </button>
                </div>
              </div>
              <div className="bankCardLine" />
            </div>
            <div>
              <Btn onClick={this._submit} text={lang.submit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function bankAuthPopup(param = {}) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  let timeoutEvn = null;
  function keydownFun(e) {
    let dom = document.getElementById('cet');
    const focusableElements = dom.getElementsByTagName('*');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];
    let isTabPressed =
      e.key === 'Tab' || (e.shiftKey && e.key === 'Tab') || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  function close() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  ReactDOM.render(<BankAuth {...param} destroy={close} />, div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('cet').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(() => {
    focus();
    trapFocus();
  }, 200);
  popupQueue.push({
    close,
  });

  return popupQueue[popupQueue.length - 1];
}

bankAuthPopup.clear = () => {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(progess => {
      progess.close();
    });
    popupQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/routes/routes/refundApply/components/BankAuthPopup/index.js